const imageLinks = document.getElementsByClassName('image-link');
for (const link of imageLinks) {
  if (link.getAttribute('data-clickable') !== 'true') {
    link.addEventListener('click', (e) => e.preventDefault());
    link.style.pointerEvents = 'none';
  } else {
    link.setAttribute('tabindex', '0');
  }
}
